import * as Actions from '../actions/actionTypes';

const initialState = {
    isFetching: false,
    contentCreated: false,
    error:false,
    message : '',
    data : {}
  };
  
  // receiving response sent by action according to type of action
  export default function generateReportActions(state = initialState, action) {
      //console.log(action,'action');
      let { payload } = action;
    switch (action.type) {
      case Actions.CREATEAPPUSERSREPORTREQUEST:
        return { 
            isFetching: true,
            contentCreated: false,
            error:false,
            data:{},
            message : ''
        };
        break;
  
      case Actions.CREATEAPPUSERSREPORTSUCCESS:
        return { 
            isFetching: false,
            contentCreated: true,
            error:false,
            message : payload.message,
            data: payload.data
        };
        break;
  
      case Actions.CREATEAPPUSERSREPORTERROR:
        return { 
            isFetching: false,
            contentCreated: false,
            error:true,
            data : payload,
            message : payload.message,

         };
        break;
        break;

      default:
        return state;
    }
  }
  